module.exports = __webpack_public_path__ + "static/media/9.ee444063.png";